import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import useTitle from "../hooks/TitleManager";

/**
 * Paramètres au niveau organisation (shell identique aux autres pages paramètres).
 * Brancher ici les appels API / sections quand le back sera disponible.
 */
const SettingsOrganization = () => {
  useTitle({ title: "Paramètres - Organisation" });

  return (
    <PageContainer type={"organization_settings"}>
      <SettingsLayout>
        <div className="flex flex-col gap-6">
          <h1 className="ft-xl font-semibold text-gray-900 pl-4">
            Paramètres de l&apos;organisation
          </h1>
          <div className="ft-lg rounded-lg border border-gray-100 bg-white px-4 py-6 text-gray-500">
            Les options d&apos;organisation seront disponibles ici.
          </div>
        </div>
      </SettingsLayout>
    </PageContainer>
  );
};

export default SettingsOrganization;
